<template>
  <ModalPlay variant="panel" size="md" :title="$t('my_courses.other_plataforms.title')" @close="$emit('close')">
    <div
      v-if="otherPlatforms.length > 0"
      class="tw:flex-col"
    >
      <div
        v-for="platform in otherPlatforms"
        :key="platform.id"
        class="tw:border-b tw:border-[var(--divider-color)] tw:flex tw:py-4 tw:justify-between tw:w-full"
      >
        <TextPlay
          size="sm"
          color="var(--fontcolor)"
          weight="semibold"
          :text="platform.name"
        />
        <div
          class="tw:flex tw:gap-2 tw:cursor-pointer"
          @click="redirectTo(platform)"
        >
          <TextPlay
            size="sm"
            weight="semibold"
            color="var(--maincolor)"
            :text="$t('my_courses.other_plataforms.access_platform')"
          />

          <IconGoogle
            size="16px" color="var(--maincolor)"
            name="open_in_new"
          />
        </div>
      </div>
    </div>
  </ModalPlay>
</template>

<script lang="ts" setup>
defineEmits(['close'])

import { ModalPlay } from '@/components/atomic'
import { computed } from "vue";
import { useStateStore } from "@/store/state.store";
import { play } from "@voomp/play-back";
import { ref } from "vue";
import { onMounted } from "vue";
import { useAuthStore } from "@/store/auth.store";

interface Site {
	id: number;
	subdomain: string;
	[key: string]: unknown;
}

interface _Me {
	current?: {
		currentSite?: Site;
	};
	member?: {
		sites?: Site[];
	};
}

const sites = ref<Array<Site>>([])

const authStore = useAuthStore()
const stateStore = useStateStore()

const otherPlatforms = computed<Site[]>(() => {
	const currentSite = stateStore.site;
	if (!currentSite) {
		return [];
	}

	return sites.value.filter(site => site.id !== currentSite.id) ?? [];
});

async function fetch() {
	const resp = await play.site.list_by_current_member({})
	sites.value = resp as Array<Site>
}

onMounted(() => {
	fetch()
})

function _getAuthSiteBySiteId(siteId: number): Site | undefined {
	return sites.value.find(site => site.id === siteId);
}

function redirectTo(platform: Site) {
	authStore.SignInSite({ siteId: platform.id })
}

</script>
